
import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import WorkPerformanceDashboardHeader from "@/components/dashboard/WorkPerformanceDashboardHeader";
import WorkPerformanceSummaryCards from "@/components/dashboard/WorkPerformanceSummaryCards";
import WorkPerformanceChartSection from "@/components/dashboard/WorkPerformanceChartSection";
import WorkPerformanceRecentEntries from "@/components/dashboard/WorkPerformanceRecentEntries";
import WorkPerformanceRecommendations from "@/components/dashboard/WorkPerformanceRecommendations";
import PageSEO from "@/components/seo/PageSEO";

const WorkPerformance = () => {
  const [timeRange, setTimeRange] = useState("30days");

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Performance no Trabalho",
      item: "https://metrocalma.org/performance-trabalho"
    }
  ];

  const structuredData = {
    "@type": "Service",
    "name": "Análise de Performance no Trabalho",
    "description": "Monitore e melhore seu desempenho profissional com insights baseados em dados e recomendações personalizadas.",
    "provider": {
      "@type": "Organization",
      "name": "metrocalma"
    },
    "serviceType": "Professional Development Service",
    "areaServed": "BR"
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Performance no Trabalho - metrocalma | Produtividade e Bem-estar Profissional"
        description="Acompanhe seu desempenho profissional com análises inteligentes, métricas de produtividade e estratégias personalizadas para melhorar seu bem-estar no trabalho."
        canonicalUrl="https://metrocalma.org/performance-trabalho"
        keywords="performance trabalho, produtividade, bem-estar profissional, análise desempenho, desenvolvimento profissional"
        pageName="Performance no Trabalho"
        pageType="Service"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <WorkPerformanceDashboardHeader timeRange={timeRange} setTimeRange={setTimeRange} />
      <WorkPerformanceSummaryCards />
      <WorkPerformanceChartSection />
      <WorkPerformanceRecentEntries />
      <WorkPerformanceRecommendations />
    </MainLayout>
  );
};

export default WorkPerformance;
